import type { AnyAction } from "../lib";
import { when } from "util/support";

import { authLogoutActionType } from "features/auth/actionTypes";
import { logoutThunk } from "features/auth/thunk";

export const resetStore = ([state, action]: [unknown, AnyAction]): [
    unknown,
    AnyAction
] => [
    when(
        logoutThunk.fulfilled.match(action) ||
        [authLogoutActionType].includes(action.type),
        undefined,
        state
    ),
    action
];

export default resetStore;
